/*
 * Generated type guards for "ild-exception.type.ts".
 * WARNING: Do not manually change this file.
 */
import { IldException } from './ild-exception.type'

export function isIldException(obj: unknown): obj is IldException {
  const typedObj = obj as IldException
  return (
    ((typedObj !== null && typeof typedObj === 'object') ||
      typeof typedObj === 'function') &&
    typeof typedObj['name'] === 'string' &&
    typeof typedObj['message'] === 'string' &&
    (typeof typedObj['stack'] === 'undefined' ||
      typeof typedObj['stack'] === 'string') &&
    ((typedObj['error'] !== null && typeof typedObj['error'] === 'object') ||
      typeof typedObj['error'] === 'function') &&
    (typedObj['error']['cause'] === null ||
      typeof typedObj['error']['cause'] === 'string') &&
    (typedObj['error']['error'] === null ||
      typeof typedObj['error']['error'] === 'string') &&
    (typedObj['error']['message'] === null ||
      typeof typedObj['error']['message'] === 'string') &&
    (typedObj['error']['path'] === null ||
      typeof typedObj['error']['path'] === 'string') &&
    (typedObj['error']['status'] === null ||
      typeof typedObj['error']['status'] === 'number') &&
    (typedObj['error']['timestamp'] === null ||
      typeof typedObj['error']['timestamp'] === 'string')
  )
}
